var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider } from "@mui/material/styles";
import { Card } from '@mui/material';
import theme from '../theme';
import { Section } from './section';
var DashboardWidget = function (props) {
    var _a;
    return (_jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsx(Card, __assign({}, props, { sx: __assign({ flex: props.flex, '&:hover': { boxShadow: '0px 12px 18px #0000001A' } }, ((props === null || props === void 0 ? void 0 : props.sx) || {})) }, { children: _jsx(Section, __assign({ title: props.head, description: props.description, components: {
                    actions: Object.assign({}, (_a = props.actions) === null || _a === void 0 ? void 0 : _a.map(function (ele) { return function () { return ele; }; }))
                } }, { children: props.children })) })) })));
};
export default DashboardWidget;
